import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Icon } from '@chargify/icons';

import { Heading } from '../../atoms';
import { Header, IconWrapper } from './Accordion.styles';
import { accordionMotion } from './motion';

export type Props = {
  /**
   * Header label
   */
  header: string;
  /**
   * Children nodes
   */
  children: React.ReactNode;
  /**
   * Expand state
   */
  isExpanded?: boolean;
  /**
   * Click event handler
   */
  onClick: (isExpanded: boolean) => void;
  /**
   * Accordion size variant
   */
  variant?: 'regular' | 'small';
};

const Accordion = ({
  children,
  header,
  onClick,
  variant = 'regular',
  isExpanded = true,
}: Props) => {
  const isRegular = variant === 'regular';
  return (
    <div>
      <Header
        data-testid="accordion-header"
        onClick={() => onClick(!isExpanded)}
        paddingBottom={isRegular ? 5 : 2}
      >
        <Heading variant={isRegular ? 'h4' : 'h5'} color="inherit">
          {header}
        </Heading>
        <IconWrapper isExpanded={isExpanded}>
          <Icon size={isRegular ? 16 : 12} fill="inherit" type="chevronDown" />
        </IconWrapper>
      </Header>
      <AnimatePresence>
        {isExpanded && (
          <motion.div {...accordionMotion} style={{ overflowY: 'clip' }}>
            {children}
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
};

export default Accordion;
